import { api } from "../api";

export const FEATURE_KEYS = [
  "deposit",
  "withdraw",
  "sbp_qr",
  "exchange",
  "cards",
  "card_issue",
  "aml",
  "services_payment",
  "swift",
  "foreign_card",
] as const;

export type FeatureKey = (typeof FEATURE_KEYS)[number];

export interface FlagState {
  enabled: boolean;
  message?: string | null;
  disabledUntil?: string | null;
}

export interface FeatureFlagsSnapshot {
  global: FlagState;
  features: Record<FeatureKey, FlagState>;
}

export async function getFeatureFlags(): Promise<FeatureFlagsSnapshot> {
  const { data } = await api.get<FeatureFlagsSnapshot>("/feature-flags");
  return data;
}
